export default __webpack_public_path__ + "static/media/wrong2-a.b85797ff.png";